import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'

import { getFullName, formatDate } from '../helpers'
import { ROUTES } from '../constant'
import {
  getClient,
} from '../actions/admin'

import Loading from '../components/Loading'
import Section from '../components/Section'
import Breadcrumb from '../components/Breadcrumbs'
import CastingAutomation from '../components/CastingAutomation'


const styles = theme => ({
  section: {
    flex: 1,
    marginRight: 20,
  },
  sectionInfo: {
    width: 350,
  },
  smokeColor: {
    color: 'silver',
  },
  header: {
    position: 'relative',
    alignItems: 'flex-start',

    [theme.breakpoints.down('lg')]: {
      alignItems: 'center',
    },
  },
  type: {
    left: 0,
    position: 'absolute',
    top: 'calc(100% - 30px)',

    '& > *': {
      width: 50,
      height: 50,
    },
  },
  avatar: {
    width: 200,
    height: 200,
    margin: '0 auto',
  },
  separator: {
    [theme.breakpoints.down('lg')]: {
      display: 'none',
    },
  },
  justifyCenter: {
    justifyContent: 'space-between',
  },
  modalContainer: {
    top: '50%',
    left: '50%',
    width: '90%',
    maxWidth: 1166,
    height: '60vh',
    outline: 'none',
    position: 'absolute',
    backgroundSize: 'cover',
    transform: 'translateX(-50%) translateY(-50%)',
    backgroundPosition: 'center',
  },
})


class Client extends Component {
  /* LIFECYCLE */

  /**
   * @componentWillMount
   */
  componentWillMount() {
    if (this.props.isConnected) {
      this.props.getClient(this.props.match.params.id)
    }
  }


  /**
   * @componentWillReceiveProps
   * @param {*} nextProps - Next properties of the Component
   */
  componentWillReceiveProps(nextProps) {
    const {
      match,
      location,
      isConnected,
    } = nextProps

    if ((location.pathname !== this.props.location.pathname && isConnected) || (isConnected && !this.props.isConnected)) {
      this.props.getClient(match.params.id)
    }
  }


  /* METHODS */

  handleItemClick = (item) => {
    this.props.history.push(`${ROUTES.CASTINGS}/${item.objectID}`)
  }


  /* RENDER */

  /**
   * @render
   * @returns {JSX}
   */
  render() {
    const {
      client,
      classes,
      isLoading,
    } = this.props
    const castings = (client && client.castings) || []

    return (
      <div>
        <Breadcrumb
          data={[
            { label: 'Home', to: ROUTES.HOME },
            { label: 'Clients', to: ROUTES.CLIENTS },
            client ? getFullName(client) : 'Client',
          ]}
        />

        <Grid container direction="row" wrap="nowrap" className={classes.root}>
          <Grid container direction="column" wra="nowrap">
            <Section title="Castings" className={classes.section}>
                <CastingAutomation
                  disableSearch
                  disablePagination
                  items={castings}
                  isLoading={isLoading}
                  onClick={this.handleItemClick}
                />
              </Section>
          </Grid>

          <Grid container direction="column" alignItems="center" justify="flex-start" className={classes.sectionInfo}>
            <Section title="Infos" className={classes.sectionInfo}>
              {isLoading && <Loading centered />}
              {client && (
                <>
                  <Grid container wrap="nowrap" className="mt1">
                    <Typography className={classes.smokeColor}>Name:</Typography>
                    <Typography className="ml1">{getFullName(client)}</Typography>
                  </Grid>
                  <Grid container wrap="nowrap" className="mt1">
                    <Typography className={classes.smokeColor}>Email:</Typography>
                    <Typography className="ml1">{client.email}</Typography>
                  </Grid>
                  <Grid container wrap="nowrap" className="mt1">
                    <Typography className={classes.smokeColor}>Phone:</Typography>
                    <Typography className="ml1">{client.phone_number}</Typography>
                  </Grid>
                  <Grid container wrap="nowrap" className="mt1">
                    <Typography className={classes.smokeColor}>Register date:</Typography>
                    <Typography className="ml1">{formatDate(client.created_at)}</Typography>
                  </Grid>
                  <Grid container wrap="nowrap" className="mt1">
                    <Typography className={classes.smokeColor}>Country:</Typography>
                    <Typography className="ml1">{client.country || 'N/A'}</Typography>
                  </Grid>
                </>
              )}
            </Section>
          </Grid>
        </Grid>
      </div>
    )
  }
}


Client.propTypes = {
  history: PropTypes.bool.isRequired,
  match: PropTypes.object.isRequired,
  getClient: PropTypes.func.isRequired,
  editClient: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  location: PropTypes.object.isRequired,
  isConnected: PropTypes.bool.isRequired,
}


const mapStateToProps = state => ({
  client: state.admin.client,
  isLoading: state.app.isLoading,
  isConnected: state.user.isConnected,
})


export default connect(mapStateToProps, {
  getClient,
})(withStyles(styles)(Client))
